import type { GetStaticPaths, NextPage } from "next";

import type { LookbookProps } from "../../lookbook";
import { getLookbookProps } from "../../lookbook";
import { PreviewMode } from "../../providers/PreviewMode";
import { handleStaticProps } from "../../request_handler";
import { LookbookView } from "../../views/LookbookView";

export type PageProps = LookbookProps & {
  isPreviewMode: boolean;
};

const Page: NextPage<PageProps> = (props) => {
  const { isPreviewMode } = props;

  return (
    <PreviewMode isPreviewMode={isPreviewMode}>
      <LookbookView {...props} />
    </PreviewMode>
  );
};

export default Page;

export const getStaticProps = handleStaticProps<PageProps, { slug: string[] }>(
  async (ctx) => {
    const { params, preview } = ctx;

    const props = await getLookbookProps(params?.slug, "/_story");

    if (!props) {
      return { notFound: true };
    }

    return {
      revalidate: 10,
      props: {
        ...props,
        view: { mobile: "story", desktop: "feed" },
        isPreviewMode: preview ?? false,
      },
    };
  },
);

export const getStaticPaths: GetStaticPaths<{
  slug: string[];
}> = async () => {
  return { paths: [], fallback: "blocking" };
};
